import request from '../../utils/Request';
import { Methods } from '../../config';

const baseURL = 'alert/alertMessage';

const alertMessageService = {
  getMessages: (data, userId) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(userId)}`,
      data,
    });
  },

  getMessageCount: (userId) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/count/${encodeURIComponent(userId)}`,
    });
  },

  markMessageAsRead: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/markAsRead`,
      data,
    });
  },
};
export default alertMessageService;
